<script setup lang="ts">
import { computed } from "vue";
import SVGWarn from "../svg/SVGWarn.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { SVGWarn },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    type?: "none" | "warn";
    text?: string;
    color?: string;
  }>(),
  {
    type: "none",
    text: "",
    color: "#333333"
  }
);

const isNotTypeNone = computed(() => props.type !== "none");
const isTypeWarn = computed(() => props.type == "warn");

defineExpose({});
</script>

<template>
  <div
    class="text"
    :style="{
      color: props.color
    }"
  >
    <div class="icon">
      <slot name="icon">
        <SVGWarn v-if="isTypeWarn"></SVGWarn>
      </slot>
    </div>
    <div
      class="ellipsis"
      :style="{ marginLeft: isNotTypeNone ? '0.3em' : '0' }"
    >
      <slot>{{ props.text }}</slot>
    </div>
  </div>
</template>

<style scoped>
.text {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 1em;
  line-height: 1;
  max-width: 100%;
}
.icon {
  font-size: 0;
  flex: 0 0 auto;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  word-break: break-all;
}
</style>
